import React, { forwardRef, useState, useImperativeHandle, useEffect } from "react";

import RadioItem from "./RadioItem/RadioItem";
import './RadioSelector.css';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';

const RadioSelector = forwardRef((props, ref) => {

    const { Label, Options, InitialSelection, Mandatory, OnSelect } = props;

    // Função para obter o índice pelo ID
    function GetIndexById(id) {
        if (!Options || Options.length === 0) return -1;
        
        let itemIndex = -1;
        for (var index = 0; index < Options.length; index++) {
            // Converte ambos para string para garantir comparação consistente
            if (String(Options[index].id) === String(id)) {
                itemIndex = index;
                break;
            }
        }
        return itemIndex;
    }

    // Inicializa o índice selecionado com base no valor inicial
    const [currentSelectedIndex, setCurrentSelectedIndex] = useState(() => {
        if (InitialSelection !== undefined && InitialSelection !== null) {
            const index = GetIndexById(InitialSelection);
            return index !== -1 ? index : 0; // Se não encontrar, usa o primeiro item (Não informado)
        }
        return -1; // Nenhuma seleção
    });

    useImperativeHandle(ref, () => ({
        Validate() {
            if (ValidateValue()) {
                SetNormalState();
                return true;
            }
            else {
                SetErrorState();
                return false;
            }
        },
        GetValue() {
            return currentSelectedIndex == -1 ? null :  Options[currentSelectedIndex].id;
        },
        SetValue(value) {
            SetNormalState();
            setCurrentSelectedIndex(GetIndexById(value));
        },
        SetError(message) {
            SetErrorState();
        }
    }));

    useEffect(() => {
        if (currentSelectedIndex != -1) {
            SetNormalState();
        }
       
    }, [currentSelectedIndex]);

    function ValidateValue() {
        if (Mandatory) {
            if (currentSelectedIndex == -1) {
                return false
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    }

    function SetNormalState() {
        setCurrentClassState("radio-selector-options-list");
    }

    function SetErrorState() {
        setCurrentClassState("radio-selector-options-list-error");
    }

    // A função GetIndexById foi movida para antes da inicialização do estado

    function OnItemClickHandler(index) {
        SelectItem(index);
    }

    function SelectItem(index) {
        SetNormalState();
        setCurrentSelectedIndex(index);
        OnSelect(index);
    }

    let count = -1;

    let [currentClassState, setCurrentClassState] = useState("radio-selector-options-list");

    return (
        <div className="radio-selector-content">
            <FormControl size="small" fullWidth>
                <div className="radio-selector-horizontal">
                    <div className="radio-selector-label">
                        <span className="radio-selector-label-text">
                            {Label}{Mandatory && <span className="radio-selector-mandatory">*</span>}
                        </span>
                    </div>
                    <div className={currentClassState} style={{ display: 'flex', alignItems: 'center' }}>
                        <RadioGroup
                            row
                            value={currentSelectedIndex !== -1 ? Options[currentSelectedIndex].id : ""}
                            onChange={(event) => {
                                const newIndex = GetIndexById(event.target.value);
                                setCurrentSelectedIndex(newIndex);
                                if (OnSelect) OnSelect(Options[newIndex].id);
                            }}
                        >
                            {Options.map((option) => (
                                <FormControlLabel
                                    key={option.id}
                                    value={option.id}
                                    control={<Radio size="small" sx={{ padding: '2px', '&.Mui-checked': { color: '#5A80FB' } }} />}
                                    label={<span style={{ fontSize: '13px' }}>{option.Label}</span>}
                                    sx={{ margin: '0 2px' }}
                                    disabled={props.Disabled}
                                />
                            ))}
                        </RadioGroup>
                    </div>
                </div>
            </FormControl>
        </div>
    );
});

export default RadioSelector;